import { nanoid } from 'nanoid'

import { STORAGE_PREFIX } from '../../constants'

import { DeviceId } from './device-id'

const DEVICE_ID_KEY = `${STORAGE_PREFIX}/v1/device-id`

export const getFallbackDeviceIdFromLocalStorage = (): DeviceId => {
  const deviceId = window.localStorage.getItem(DEVICE_ID_KEY)

  if (deviceId === null) {
    const newDeviceId = DeviceId(nanoid())
    window.localStorage.setItem(DEVICE_ID_KEY, newDeviceId)

    return newDeviceId
  } else {
    return DeviceId(deviceId)
  }
}
